import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  currentUserIdSelector,
  currentCohortPathSelector,
} from '../Auth/selectors';
import { groupsByUserByCohortByCategory } from './selectors.common';

export * from './selectors.common';

export const currentUserGroupsByCategory = createSelector(
  currentUserIdSelector,
  currentCohortPathSelector,
  groupsByUserByCohortByCategory,
  (userId, cohortPath, groups) => {
    return groups.getIn([userId, cohortPath], Immutable.Map());
  }
);
